export const getParentsOfTypeUntilClass = (element, tagName, className) => {
  const parents = [];
  let currentElement = element.parentElement;

  while (currentElement && !currentElement.classList.contains(className)) {
    if (currentElement.tagName.toLowerCase() === tagName.toLowerCase()) {
      parents.push(currentElement);
    }
    currentElement = currentElement.parentElement;
  }

  return parents;
};

export const getSiblingByClass = (element, className) => {
  return [...element.parentNode.children].find(
    sibling => sibling !== element && sibling.classList.contains(className)
  );
};

export const showElement = (element, duration, callback = null) => {
  // Hide the element and store the height
  element.style.position = 'fixed';
  element.style.visibility = 'hidden';
  element.style.height = `auto`;

  const { height } = getComputedStyle(element);

  element.style.position = null;
  element.style.visibility = null;
  element.style.height = 0;

  // Change height from 0 to the stored value
  setTimeout(() => {
    element.style.height = height;
  }, 1);
  setTimeout(() => {
    element.style.height = 'auto';

    if (callback) {
      callback();
    }
    // Set height to auto when the transition is done. These timeouts must match the transition duration
  }, duration - 1);
};

export const hideElement = (element, callback = null) => {
  // Get the actual height of the element and set it
  element.style.height = `auto`;
  const { height } = getComputedStyle(element);
  element.style.height = height;

  // Trigger the transition by setting height to 0
  setTimeout(() => {
    element.style.height = 0;

    if (callback) {
      callback();
    }
  }, 1);
};

/**
 * Applicable for elements that always have a display: none style,
 * this adds a display: block class and animates the height from 0 to the full height.
 * 
 * @param element
 * @param showClass
 * @param duration
 * @param callback
 * @returns
 */
export const showElementFromDisplayNone = (element, showClass, duration, callback = null) => {
  if (element.classList.contains("collapsing-no-overflow") || element.classList.contains(showClass)) return;
  
  element.classList.add("collapsing-no-overflow");
  element.style.height = "0px";
  element.classList.add(showClass);
  
  // Force a reflow
  element.offsetHeight; // eslint-disable-line
  
  const fullHeight = element.scrollHeight + "px";
  element.style.transition = `height ${duration}ms ease-in-out`;
  element.style.height = fullHeight;
  
  setTimeout(() => {
      element.classList.remove("collapsing-no-overflow");
      element.style.height = "auto";

      if (callback) {
        callback();
      }
  }, duration);
};

/**
 * Applicable for elements that always have a display: none style,
 * this removes a display: block class and animates the height from full height to 0.
 * 
 * @param element
 * @param showClass
 * @param duration
 * @param callback
 * @returns
 */
export const hideElementToDisplayNone = (element, showClass, duration, callback = null) => {
  if (!element.classList.contains(showClass)) return;
  
  const fullHeight = element.scrollHeight + "px";
  element.style.height = fullHeight;
  element.offsetHeight; // eslint-disable-line
  
  element.style.transition = `height ${duration}ms ease-in-out`;
  element.style.height = "0px";
  element.classList.add("collapsing-no-overflow");
  
  setTimeout(() => {
      element.classList.remove(showClass);
      element.classList.remove("collapsing-no-overflow");

      if (callback) {
        callback();
      }
  }, duration);
};